var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pie-chart',{attrs:{"class-names":"mt-8","title":"Meilleures catégories","subTitle":"dans discover (par nombre d'articles)","series":_vm.series,"labels":_vm.labels,"colors":_vm.colors,"formatter":_vm.formatter}})}
var staticRenderFns = []

export { render, staticRenderFns }